import React from "react";
import { Grid, Row, Col } from 'react-flexbox-grid';
import cn from 'classnames';
import * as Icon from '../../../components/Icons';
import styles from './styles.module.css';

const data = [
	{title:"Internet Access", availables:["Wi-Fi"]},
	{title:"Beauty Wellness", availables:["Gym-Fitness Center","Spa","Sauna","Barber"]},
	{title:"General", availables:["Non Smoking","Multilingual Staff","Library"]},
	{title:"Front Desk Services", availables:["Front Desk","Concierge","Laundry Service","Dry Cleaning Service","Luggage Store"]},
	{title:"Family Friendly", availables:["Baby Sitting"]},
	{title:"Pool & Beach", availables:["Private Beach", "OutDoor Pool", "Pool Bar"]},
	{title:"Activities", availables:["Tennis Court","Football field","Picnic Area"]},
]

const Amenities = (props) => {
	return (
		<Grid fluid>
			<Row>
				<Col sm={12}>
					<div className={styles.borderBottom} ref={props.refProp}>
						<span className={styles.title}>Hotel Amenities</span>
					</div>
					<div className={cn([styles.flexContainer,styles.flexStart,styles.wrap,styles.amenities])}>
						{data.map((amenities)=> {
							return(
								<div className={styles.amenity}>
									<p className={styles.subtitle}>{amenities.title}</p>
									<div className={styles.wrap}>
										{amenities.availables.map((amenity)=> {
											return(
												<div className={styles.flexContainer}>
													<Icon.Check fill={"var(--color-primary)"} style={{marginRight:"0.5rem"}} />
													<p className={styles.icon}>{amenity}</p>
												</div>
											)

										})}
									</div>
								</div>
							)
						})}
					</div>
				</Col>
			</Row>
		</Grid>
	)
};
export default Amenities;